(function () {
  var ROOT_SELECTOR = '[data-about-story-why]';
  var TIMELINE_SELECTOR = '[data-timeline-list]';
  var TOGGLE_SELECTOR = '[data-timeline-toggle]';
  var ITEM_SELECTOR = '[data-timeline-item]';

  function initTimeline(root) {
    var list = root.querySelector(TIMELINE_SELECTOR);
    var toggle = root.querySelector(TOGGLE_SELECTOR);

    if (!list || !toggle || list.dataset.timelineReady === 'true') return;

    list.dataset.timelineReady = 'true';

    var items = Array.prototype.slice.call(list.querySelectorAll(ITEM_SELECTOR));
    var visibleCount = parseInt(list.getAttribute('data-mobile-visible') || '3', 10);
    var viewMore = toggle.getAttribute('data-view-more') || 'View More';
    var viewLess = toggle.getAttribute('data-view-less') || 'View Less';

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function collapse() {
      list.classList.remove('is-expanded');
      toggle.textContent = viewMore;
      toggle.setAttribute('aria-expanded', 'false');
      updateVisibility();
    }

    function expand() {
      list.classList.add('is-expanded');
      toggle.textContent = viewLess;
      toggle.setAttribute('aria-expanded', 'true');
      updateVisibility();
    }

    function updateVisibility() {
      var mobile = isMobile();
      var expanded = list.classList.contains('is-expanded');
      var hideExtra = mobile && !expanded && items.length > visibleCount;

      items.forEach(function (item, index) {
        var hidden = hideExtra && index >= visibleCount;
        item.classList.toggle('is-collapsed', hidden);
      });

      if (!mobile || items.length <= visibleCount) {
        toggle.classList.remove('is-visible');
        list.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');
        items.forEach(function (item) {
          item.classList.remove('is-collapsed');
        });
        return;
      }

      toggle.classList.add('is-visible');
    }

    toggle.addEventListener('click', function () {
      if (list.classList.contains('is-expanded')) {
        collapse();
      } else {
        expand();
      }
    });

    window.addEventListener('resize', updateVisibility);
    collapse();
  }

  function initSection(root) {
    if (root.__aboutStoryWhyReady) return;
    root.__aboutStoryWhyReady = true;
    initTimeline(root);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(ROOT_SELECTOR);

    if (root) {
      root.__aboutStoryWhyReady = false;
      var list = root.querySelector(TIMELINE_SELECTOR);
      if (list) list.dataset.timelineReady = 'false';
      initSection(root);
    }
  });
})();
